import { makeStyles, StepIconProps } from "@material-ui/core";
import { File, Video } from "react-feather";
import { Language } from "../../models/languageDto";
import { TypeCourse } from "../../models/typeCourseDto";
import clsx from "clsx";

const LANGS = {
  EN: "flag-icon flag-icon-us",
  FR: "flag-icon flag-icon-fr",
};

const SUPPORT_TYPE = {
  PDF: File,
  VIDEO: Video,
};

export const getFlag = (language: Language) => {
  const classname = LANGS[Language[language]] || "flag-icon flag-icon-fr";
  return classname;
};

export const getStepIcon = (typeCourse?: TypeCourse) => {
  const Component = SUPPORT_TYPE[TypeCourse[typeCourse]] || File;
  return <Component />;
};

export function ColorlibStepIcon(props: StepIconProps) {
  const classes = useStyles();
  const { active, completed } = props;
  const icons: { [index: string]: React.ReactElement } = {
    1: <p>1</p>,
    2: <p>2</p>,
  };
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

export const useStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 30,
    height: 30,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundColor: "green",
  },
  completed: {
    backgroundColor: "green",
  },
});
